/* -- START -- optimized autocomplete - Search click event */

window.addEventListener('click', function(event) {
  const header = event.target.closest("#header-outer");
  const father = event.target.closest("html") || event.target.closest("body");
  
  if (header && father && !father.querySelector('.autocomplete') && father.querySelector("#content")) {      
    father.querySelector("#content").classList.remove("overlay-visible");
    document.documentElement.classList.remove("overlay-visible");
  }
});


function hooksAC() {
  
  window.FastAutocomplete.registerHook('render-autocomplete-product-item', ({ product, index, element }) => {
    const mainparent = document.body.querySelector("#content");
    const ACParent = element.closest(".autocomplete-inner");

    // Click event for dimmed background
    mainparent.addEventListener('click', function() {
      mainparent.classList.remove("overlay-visible");
      document.documentElement.classList.remove("overlay-visible");
    });

    // Auto-close autocomplete after checking
    setTimeout(() => {
      if (!ACParent) {
        mainparent.classList.remove("overlay-visible");
        document.documentElement.classList.remove("overlay-visible");
      }
    }, 500);

    // Form submit event
    const liveSearchForm = document.body.querySelector('.live-search__form[data-live-search-form]');
    if (liveSearchForm) {
      liveSearchForm.addEventListener('submit', function() { 
        setTimeout(() => mainparent.classList.remove("overlay-visible"), 500);
      });
    }

    // Enter key press event
    const searchInput = document.body.querySelector('.live-search__query-input');
    if (searchInput) {
      searchInput.addEventListener('keydown', function(event) {
        if (event.keyCode === 13) {
          setTimeout(() => mainparent.classList.remove("overlay-visible"), 500);
        }
      });
    }

    const glassSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" fill="black" viewBox="0 0 512 512"><path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>`;
    const parser = new DOMParser();
    const svgElement = parser.parseFromString(glassSVG, "image/svg+xml").documentElement;

    if (ACParent) {
      if (window.innerWidth < 820 && document.body.querySelector(".fast-autocomplete-input")) {
        const fastAutocompleteInput = document.body.querySelector(".fast-autocomplete-input");
        if (!fastAutocompleteInput.classList.contains("cstm-event")) {
          fastAutocompleteInput.classList.add("cstm-event");
          fastAutocompleteInput.addEventListener("focus", function() {
            const autocomplete = ACParent.closest(".autocomplete");
            if (autocomplete) {
              autocomplete.style.display = "block";
            }
          });
        }
      }

      ACParent.querySelectorAll(".fs-recent-list .children a").forEach((recentElement) => {
        if (!recentElement.querySelector("svg")) {
          recentElement.insertAdjacentElement('afterbegin', svgElement);
        }
      });

      mainparent.classList.add("overlay-visible");
      document.documentElement.classList.add("overlay-visible");

      ACParent.querySelectorAll(".fast-ac-item").forEach((item) => {
        if (!item.classList.contains("cstm-event")) {
          item.classList.add("cstm-event");
          item.addEventListener('click', function() {
            setTimeout(() => {
              const buttonText = document.body.querySelector(".button-text");
              if (buttonText) {
                buttonText.click();
              }
              mainparent.click();
            }, 500);
          });
        }

        if (item.closest(".fs-category-list") && item.querySelector("a")) {
          item.querySelector("a").addEventListener('click', function(event) {
            event.preventDefault();
            const headerOuter = document.body.querySelector("#header-outer");
            if (headerOuter) {
              headerOuter.click();
            }
            if (ACParent.closest(".autocomplete") && window.innerWidth < 820) {
              setTimeout(() => { ACParent.closest(".autocomplete").style.display = "none"; }, 300);
            }
            mainparent.click();
          });
        }
      });
    }
  });
}



if (window.FastAutocomplete) {
  hooksAC();
} else {
  window.addEventListener('fast-autocomplete-ready', hooksAC);
}

/* -- END -- optimized autocomplete - Search click event */

// [SEARCH INPUT 배경 오버레이] --------START---------

function searchInputClear(searchInput, clearOverlay = true) {
    searchInput.addEventListener('keyup', (e) => {
        if (e.key === 'Enter') {
            searchInput.value = '';
            searchInput.blur();
            if (clearOverlay) {
                const siteOverlay = document.getElementById("site-overlay");
                if (siteOverlay) {
                    setTimeout(() => siteOverlay.setAttribute("data-animation-state", "closed"), 500);
                }
            }
        }
    });
}

document.querySelectorAll('#search_main, #Search-In-Modal-1').forEach(input => {
    searchInputClear(input, input.id !== "Search-In-Modal-1");
});

function Getattributevalue(attributes, name) {
    return attributes?.find(att => att[0] === name)?.[1][0] || "";
}

// [SEARCH INPUT 배경 오버레이] --------END---------
